import React from 'react'
import { Route, Routes } from 'react-router-dom';
import ProductPage from '../pages/ProductPage';
import CallbackStatus from '../pages/CallbackStatus';
function MainRoutes() {
    return (
        <Routes>
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/payment/callback" element={<CallbackStatus />} />
        </Routes>
    )
}

export default MainRoutes;